export const coursesSelector = (state) => state.courses;
